export default __webpack_public_path__ + "static/media/dongzhi-angbao-bonus.85b6c718.webp";